const options = {
    navTabs: ".nav-tabs a",
    accorditionTabs: ".data.accordition",
    productInfomationTab: ".bls__product-tabs-content",
    productInfomationTabLayoutSecond: ".bls__products-tabs",
    tabContent: ".tab-content .tab-item",
    tabContentActive: ".tab-content .tab-item.active",
  };
   
  var BlsTab = (function(){
     return {
      eventProductTabs: function () {
        document.querySelectorAll(options.navTabs).forEach((tabToggle) => {
          tabToggle.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              const target = e.currentTarget;
              const tab_id = target.getAttribute("data-block-id");
              if (!target.closest(".data.item").classList.contains("active")) {
                for (var item of document.querySelectorAll(".data.item")) {
                  item.classList.remove("active");
                }
                for (var item of document.querySelectorAll(options.tabContent)) {
                  item.classList.remove("active");
                  item.querySelector(".tab-panel").style.display = "none";
                }
                const conditions = document.getElementById(tab_id);
                conditions.classList.add("active");
                conditions.querySelector(".tab-panel").style.display = "block";
                target.closest(".data.item").classList.add("active");
              }
            },
            false
          );
        });
      }
     }
  })()
  BlsTab.eventProductTabs()

// Acordeón FAQ con animación slide
document.querySelectorAll("h3.faq").forEach((faqToggle) => {
  faqToggle.addEventListener("click", () => {
    faqToggle.classList.toggle("active");

    const answer = faqToggle.nextElementSibling;

    if (faqToggle.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.style.opacity = "1";
      answer.style.marginTop = "0.5em";
    } else {
      answer.style.maxHeight = "0";
      answer.style.opacity = "0";
      answer.style.marginTop = "0";
    }
  });
});

// Scroll suave hacia bloques con ancla personalizada (como la descripción larga)
document.addEventListener("DOMContentLoaded", function () {
  const scrollLinks = document.querySelectorAll('[data-scroll-to]');
  const headerOffset = 100; // Ajusta según tu cabecera sticky

  scrollLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("data-scroll-to");
      const targetEl = document.querySelector(targetId);

      if (targetEl) {
        const elementPosition = targetEl.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});



// Judge.me → eliminar H1/H2 dentro del widget y del popup de reseñas
(function () {
  const ROOT_SEL = '#judgeme_product_reviews, .jdgm-widget, [class*="jdgm"]';
  const TITLE_WIDGET_HEADER = '#judgeme_product_reviews .jdgm-rev-widg__header h1, #judgeme_product_reviews .jdgm-rev-widg__header h2';
  const ANY_JDGM_HX = '[class*="jdgm"] h1, [class*="jdgm"] h2';

  function isJudgeMeNode(n) {
    return n?.nodeType === 1 && (
      n.matches?.(ROOT_SEL) ||
      n.closest?.(ROOT_SEL)
    );
  }

  function demoteHeading(h, { keepA11y = false } = {}) {
    if (!h || !/^H[1-6]$/.test(h.tagName) || h.dataset.jdgmReplaced === '1') return;
    // Evitar cambiar contenido de una reseña concreta (por si alguien pegó HTML con H2)
    if (h.closest?.('.jdgm-rev')) return;

    const p = document.createElement('p');
    p.className = h.className;
    p.innerHTML = h.innerHTML;

    // Copiar atributos (id, data-*, aria-*)
    for (const { name, value } of Array.from(h.attributes)) {
      if (name !== 'class') p.setAttribute(name, value);
    }

    // En la cabecera del widget mantenemos semántica accesible; en el popup NO
    if (keepA11y) {
      p.setAttribute('role', 'heading');
      p.setAttribute('aria-level', '2');
    }

    p.dataset.jdgmReplaced = '1';
    h.replaceWith(p);
  }

  function unhideWidget(root = document) {
    // Eliminar estilo temporal que oculta el widget si se queda pegado
    root.querySelectorAll('#judgeme_product_reviews style.jdgm-temp-hiding-style').forEach(s => s.remove());
    root.querySelectorAll('#judgeme_product_reviews .jdgm-rev-widg').forEach(el => {
      el.style.removeProperty('display');
      el.classList.remove('jdgm-temp-hidden', 'jdgm-hidden');
    });
  }

  function process(scope = document) {
    // 1) Cabecera visible del widget → demover H1/H2 pero manteniendo accesibilidad
    scope.querySelectorAll(TITLE_WIDGET_HEADER).forEach(h => demoteHeading(h, { keepA11y: true }));

    // 2) Cualquier H1/H2 dentro de Judge.me (incluye plantillas ocultas y el popup) → demover sin rol
    scope.querySelectorAll(ANY_JDGM_HX).forEach(h => {
      if (!isJudgeMeNode(h)) return;
      // Si es la cabecera principal ya tratada arriba, no repetimos
      if (h.closest?.('#judgeme_product_reviews .jdgm-rev-widg__header')) return;
      demoteHeading(h, { keepA11y: false });
    });

    // 3) Asegurar que no queda oculto por estilos temporales
    unhideWidget(scope);
  }

  function observeMutations() {
    const obs = new MutationObserver(muts => {
      let touch = false;
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (
            isJudgeMeNode(n) ||
            n.matches?.(ANY_JDGM_HX) ||
            n.querySelector?.(ANY_JDGM_HX)
          ) { touch = true; break; }
        }
        if (touch) break;
      }
      if (touch) process(document);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  function hookWriteReviewClicks() {
    // Cuando haces clic en "Escribir reseña", Judge.me suele inyectar el popup un poco después
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.jdgm-write-rev-link, [data-action="write-review"], .jdgm-ask-question-btn');
      if (!btn) return;
      // Varias pasadas escalonadas para cazar el popup y sus plantillas
      [0, 120, 300, 600, 1200].forEach(t => setTimeout(() => process(document), t));
    }, true);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(() => { process(); observeMutations(); hookWriteReviewClicks(); });
  // Una pasada extra tras load por si los scripts del app van al final
  window.addEventListener('load', () => process(), { once: true });

  // Fallback de reintentos (6 s)
  let tries = 0;
  const iv = setInterval(() => {
    process();
    if (++tries > 30) clearInterval(iv);
  }, 200);
})();